import React, { useState } from 'react';
import Card from './Card';
import Spinner from './Spinner';
// import React, { useState } from 'react';

const Cards = (props) => {
    let courses = props.courses;

    const [LikedCouses, setLikedCouses] = useState([]);
  
    let courseArray =[];
    const getcourses =  ()=>{
        
        if(props.cat === 'All')
       { Object.values(courses).forEach((couseCategory) => {
            couseCategory.forEach((Course)=>{
                courseArray.push(Course);
            })
            
        })
        return courseArray;
       }
        else return courses[props.cat];
        
    }
    return (
        <div className='flex flex-wrap justify-center gap-4 mb-4'>
           {   getcourses().map((course)=>{
           return <Card course={course}
           LikedCouses= {LikedCouses}
            setLikedCouses = {setLikedCouses}
            />}
     )  } 
           
        </div>
    );
}

export default Cards;










































// import React from 'react';
// import Card from './Card';


// const Cards = (props) => {
//     let courses = props.courses;
    
// function getCouses(){
//     let allCouses = [];
//     Object.values(courses).forEach((couseCategory) => {
//         couseCategory.forEach( Course =>{
//             allCouses.push(Course);
//         })
           
//     })
//     return allCouses;   
// }
//     return (
//         <div>
//             {
//                 getCouses().map((course)=>{
//                     <Card key= {course.id} course = {course} />
//                 })
//             }
            
//         </div>
//     );
// }

// export default Cards;
